<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectSingle" });
import { Input } from "../../inputs/index.js";
import { DataListSingle } from "../index.js";
import Icon from "../../elements/icon/Icon.svelte";
export let key;
export let options = [];
export let name;
export let isDisabled = false;
export let isRequired = false;
export let label = void 0;
export let hint = void 0;
export let placeholder = void 0;
export let blacklist = [];
export let whitelist = [];
let showList = false;
let value = void 0;
$: singleCheckedOption = key === options[0]?.key && options.length === 1;
$: whitelistedOptions = whitelist.length > 0 ? options.filter((option) => whitelist.includes(option.key)) : options;
const toggleList = () => {
    if (singleCheckedOption) {
        return;
    }
    showList = !showList;
};
const getValue = (key2) => {
    if (key2 === void 0) {
        return void 0;
    }
    const OPTION = options.find((option) => option.key === key2);
    if (OPTION === void 0) {
        return void 0;
    }
    return OPTION.label;
};
$: value = getValue(key);
const onKeyChange = (key2) => {
    showList = false;
};
$: onKeyChange(key);
let validation = "";
const setValidation = (key2, isRequired2) => {
    if (isRequired2 && key2 === void 0) {
        return "value_missing";
    }
    return "";
};
$: validation = setValidation(key, isRequired);
</script>

<div
    class = 's8-select-single'
    class:s8-no-input = { singleCheckedOption }
    class:s8-has-label = { label !== undefined }
>

    {#if Array.isArray(options)}

        <Input
            on:click = { toggleList }
            isDisabled = { isDisabled || singleCheckedOption }
            hasStyle = { false }
            { isRequired }
            { placeholder }
            { validation }
            { hint }
            { label }
            { name }
            { value }
        >
            <svelte:fragment slot='afterInput'>

                {#if !isDisabled && !singleCheckedOption}
                    <Icon
                        key = { showList ? 'chevronUp' : 'chevronDown' }
                        css = 's8-select-icon'
                        on:click = { toggleList }
                    />
                {/if}

            </svelte:fragment>

        </Input>

        <DataListSingle
            bind:key
            bind:showList = { showList }
            options = { whitelistedOptions }
            { name }
            { blacklist }
        />

    {/if}

</div>

<style>

    div.s8-select-single {
        position: relative;
        width: 100%;
        color: #272711;
    }

        div.s8-select-single :global(svg.s8-select-icon) {
            cursor: pointer !important;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            height: 14px;
            right: 10px;
        }

        div.s8-select-single :global(input) {
            caret-color: transparent;
            background: linear-gradient(180deg, rgba(39,39,17,0.06) 0%, rgba(39,39,17,0.12) 100%);
            padding-right: 30px !important;
            text-overflow: ellipsis;
        }

        div.s8-select-single :global(input):not(:disabled):hover {
                cursor: pointer !important;
                background: linear-gradient(180deg, rgba(39,39,17,0.08) 0%, rgba(39,39,17,0.14) 100%);
            }

        div.s8-select-single :global(input):not(:disabled):focus {
                background: linear-gradient(180deg, rgba(68,131,95,0.12) 0%, rgba(68,131,95,0.24) 100%);
            }

        div.s8-select-single :global(input):not(:disabled):focus::-moz-placeholder {
                    color: rgba(68,131,95,0.48) !important;
                }

        div.s8-select-single :global(input):not(:disabled):focus::placeholder {
                    color: rgba(68,131,95,0.48) !important;
                }

        div.s8-select-single :global(input.s8-touched:invalid:not(:focus)) {
            background: linear-gradient(180deg, rgba(239,35,59,0.12) 0%, rgba(239,35,59,0.24) 100%);
        }

        div.s8-select-single :global(input.s8-touched:invalid:not(:focus))::-moz-placeholder {
                color: rgba(239,35,59,0.48) !important;
            }

        div.s8-select-single :global(input.s8-touched:invalid:not(:focus))::placeholder {
                color: rgba(239,35,59,0.48) !important;
            }

        div.s8-select-single.s8-has-label :global(div.s8-datalist-single) {
                top: 50px;
            }</style>